import { useState } from 'react';
import { useNavigate } from 'react-router-dom';


function UserVerify() {
  const [files, setUpload] = useState([]);
  const [email, setEmail] = useState('');
  const [alertEmail, setAlertEmail] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const navigate = useNavigate();

  async function fetchData() {
    const form = new FormData();
    form.append('email', email);

    for (let i = 0; i < files.length; i++) {
      form.append('files', files[i], files[i].name);
      console.log(email);
      console.log(files[i].name);
    }

    try {
      setUploaded(true); // automatically b4 async
      const res = await fetch('/upload', { method: 'POST', body: form });
        const data = await res.json();
        console.log(data);
    } catch (err) {
      console.log(err);
    } finally{
      setUploaded(false);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email.trim() === '') {
      console.log('email is blank')
      setAlertEmail(true);
      return; // stop submission
    } else if (emailRegex.test(email) === false){ 
      console.log('email is not in proper format');
      setAlertEmail(false);
      return;
    } else {
      setAlertEmail(null);
      
    }
    fetchData();
  
  }

  return (
    uploaded ? <UploadingSongs/> : 
    <div>
        <div>
          <h1>Artists, are you tired of making .0003 per stream?</h1>
          <p>With MP3Juug you can DIY: Distribute it yourself.</p>
          <ol>
            <li>Enter your email and upload your .wav or mp3 music files</li>
            <li>Hit upload</li>
            <li>Enter the amount of links you want for downloads</li>
            <li>Use these links to place on physical media.</li>
          </ol>

          <form id="uploadForm" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
       
            {
              alertEmail === true ? (
               <span style={{ color: 'red', marginLeft: '10px', marginRight: '10px', fontSize: '12px' }}>
                Please enter your email address to use for uploads.
              </span>
              ): alertEmail === false ? (
                <span style={{ color: 'red', marginLeft: '10px', marginRight: '10px', fontSize: '12px' }}>
                Please enter an email address with proper format. i.e. <b>artist@example.com</b>
              </span>
              ): alertEmail === null ? <></>: <></>
            } 

            <input
              type="file"
              multiple
              onChange={(e) => setUpload(e.target.files)}
            />
            <button type="submit">Upload</button>
          </form>
        </div>
        <div>
          <button onClick={() => {navigate('/link');}} style={{fontSize: '20px'}}>Get your download links now</button>
        </div>
    </div>
);
}

function UploadingSongs() {
  return (
    <>
      <p>UPLOADING UR MUSIC..</p>
    </>
  );
}

export default UserVerify;
